module.exports = __webpack_public_path__ + "media/images/places/comuna-irma-alberta-mst-4a2fd87fb7e48970d06938285cd9be19.jpg";